var React = require('react');

function check() {
    return <g><path d="M0 0h24v24H0z" fill="none" xmlns="http://www.w3.org/2000/svg"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" xmlns="http://www.w3.org/2000/svg"/></g>
}
module.exports = check
